import { Box } from "@chakra-ui/react";
import { Section, sectionSpacingY } from "components/section";
import { useCdpIndustry } from "contexts/cdp-industry-context";
import React from "react";
import Balancer from "react-wrap-balancer";
import { Superscript, TextTitle } from "ui/text";
import { desktopOnlyDisplay, mobileOnlyDisplay } from "utils";
import { ConsiderationsTable } from "./table";
import { ConsiderationsTabs } from "./tabs";

export function CdpIndustryConsiderationsTable() {
  const { industry } = useCdpIndustry();

  return (
    <Section my="0" pb={sectionSpacingY}>
      <TextTitle
        size="lg"
        align="center"
        descriptionMaxW="600px"
        title={<Balancer>What {industry.pluralNoun} should consider when evaluating a CDP</Balancer>}
        description={
          <>
            90%
            <Superscript
              size="sm"
              text="5"
              href="https://digiday.com/marketing/the-vast-majority-of-marketers-are-unhappy-with-their-customer-data-platforms-but-then-again-not-many-are-sure-what-they-really-are/"
            />{" "}
            of marketers say their traditional CDP does not do what they need, so why do they keep buying them?
          </>
        }
        mb={{ base: "bigger", md: "huge" }}
      />

      <Box display={desktopOnlyDisplay()}>
        <ConsiderationsTable />
      </Box>

      <Box display={mobileOnlyDisplay()}>
        <ConsiderationsTabs />
      </Box>
    </Section>
  );
}
